/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function($){
 

  var item = document.getElementsByTagName("a");
  for(var i = 0, max = item.length; i < max; i++) 
{
  item[i].addEventListener("mouseover", item[i].setAttribute("title", ""), false);

}
 

       

 

 

})();
  
 
  
(function() {
  // Add custom code below this line
  document.getElementById("search_key_button").addEventListener('click', (event) => {
    document.getElementById("search_pop_input").value = document.getElementById("search_key_input").value;

    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    document.getElementById("search_pop_input").dispatchEvent(event);
  });

  document.getElementById("search_key_input").addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      document.getElementById("search_key_button").click();
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

function toggleDiv(element) {
  if (window.innerWidth < 749) {
    element.parentElement.classList.toggle('active');
  element.parentElement.children[1].style.display = element.parentElement.classList.contains('active') ? "block" : "none";
  }
}

if (document.getElementById('countdownTimer')) {
  /**
   * Adds additional leading 0's (up to len) to the number (n)
   * @param {Int} n
   * @param {Int} len
   */
  const pad = function(n, len) { // leading 0's
    var s = n.toString();
    return (new Array( (len - s.length + 1) ).join('0')) + s;
  };

  var timerRunning = setInterval(
    function countDown() {
      var now = new Date();
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      if ( (now.getDay() >= 1) && (now.getDay() <= 5) ) { // Mon - Fri
        var target = 16; // 15:00hrs is the cut-off point
        if (now.getHours() < target) { // don't do anything if we're past the cut-off point
          var hrs = (target - 1) - now.getHours();
          if (hrs < 0) hrs = 0;
          var mins = 59 - now.getMinutes();
          if (mins < 0) mins = 0;
          var secs = 59 - now.getSeconds();
          if (secs < 0) secs = 0;
          var tomorrow = new Date();
          tomorrow.setDate(now.getDate() +1);
          var tomDay = tomorrow.getDay();
          if(tomDay === 0 || tomDay === 6) {
            if(tomDay === 0) {
              tomorrow.setDate(tomorrow.getDate() + 1);
            } else if(tomDay === 6) {
              tomorrow.setDate(tomorrow.getDate() + 2);
            } 
          }
          var nextDate = days[tomorrow.getDay()] + " " + tomorrow.getDate() + " " + months[tomorrow.getMonth()];
          var str = "<span class='promo_product_head'>Order in " + '<strong>' + pad(hrs, 2) + "h " + pad(mins, 2) + "m " + pad(secs, 2) + 's</strong>' + " to receive by <strong>" + nextDate + "</strong></span>";
          document.getElementById('countdownTimer').innerHTML = str; // update countdown timer element
        }
        if (now.getHours() >= target) {
          // if past the daily deadline, show this string. 
          document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship next working day</span>";
        }
      }
      else {
        // if Saturday or Sunday show this string
        document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship Monday</span>";
      }
    }, 1000
  );
}

document.getElementById("open_reviews").addEventListener("click",(e)=>{
    e.preventDefault();
    element = document.getElementById("shopify-section-template--16452106649844__shipping");
    element.scrollIntoView();
  document.getElementById("reviews_open").style.display = "block";
});


